export interface IApiOptions {
  headers?: { [key: string]: string };
  dontParseResponse?: boolean;
  dontCatchBannedResponses?: boolean;
  dontIncludeJwt?: boolean;
}

export type IApiBody = {
  [key: string]: string | undefined | number | null | boolean | object;
};

export interface IApiResponse<T> {
  status: number;
  ok: boolean;
  payload: T;
}

export class ApiError extends Error {
  public errorPayload: any;
  public statusCode: number | undefined;

  constructor(message?: string, statusCode?: number, errorPayload?: any) {
    super(message);
    this.errorPayload = errorPayload;
    this.statusCode = statusCode;
  }
}
